import FacebookIntegrationPagesComponent from './facebook_integration_page';
import { fetchFacebookIntegrationThunks } from '../../redux/thunks/integration';
import FormCardComponent from './form_card';
import FormHeaderComponent from './form_header';
import FormTableComponent from './form_table';
import ImageClass from '../../assets';
import { useParams } from 'react-router';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, CircularProgress, Typography } from '@mui/material';
import { createDefaultFormsThunk, fetchFacebookPagesThunk, fetchFormsThunk } from '../../redux/thunks/form';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

const FormComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const [searched, setSearched] = useState<string>('');
    const [sort, setSort] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [tableView, setTableView] = useState<boolean>(true);
    const { forms, selectedFormType, assignedForms } = useSelector((state: RootState) => state.form);

    useEffect(() => {
        const fetchForms = async () => {
            setIsLoading(true);
            try {
                const parsedId = id ? parseInt(id as string, 10) : 0;
                if (selectedFormType === 'form') {
                    await Promise.all([
                        dispatch(createDefaultFormsThunk(parsedId)).unwrap(),
                        dispatch(fetchFormsThunk(parsedId)).unwrap()
                    ]);
                } else if (selectedFormType === 'facebook') {
                    const response = await dispatch(fetchFacebookIntegrationThunks(parsedId)).unwrap();
                    if (response) await dispatch(fetchFacebookPagesThunk(parsedId)).unwrap();
                }
            } catch (e) {
                // Catch errors
            } finally {
                setIsLoading(false);
            }
        };
        fetchForms();
    }, [id, selectedFormType]);

    if (isLoading) {
        return <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" height="60vh" flex={1} gap={2} >
            <CircularProgress />
            <Typography variant="subtitle1">Loading...</Typography>
        </Box>;
    }

    return <Box>
        <FormHeaderComponent
            searched={searched}
            handleAdd={() => null}
            setSearched={(val) => setSearched(val)}
            sort={sort}
            setSortValue={(val) => setSort(val)}
            isTableView={tableView}
            setTableView={(val) => setTableView(val)}

        />
        {
            selectedFormType === 'facebook'
                ? (<FacebookIntegrationPagesComponent />)
                : <></>
        }
        {
            selectedFormType === 'external'
                ? <Box minHeight="60vh" display="flex" flexDirection="column" gap={1} alignItems="center" justifyContent="center">
                    <Typography variant="subtitle1" color="textSecondary">No websites have been added yet</Typography>
                    <img src={ImageClass.noForm} height="300px" />
                </Box>
                : <></>
        }
        {
            selectedFormType === 'form'
                ? forms.length === 0 && assignedForms.length === 0
                    ? <Box minHeight="60vh" display="flex" flexDirection="column" gap={1} alignItems="center" justifyContent="center">
                        <Typography variant="h4" color="textSecondary">No Forms Available</Typography>
                        <Typography variant="subtitle1" color="textSecondary">Create a new forms by clicking create new form</Typography>
                        <img src={ImageClass.noActivity} height="500px" />
                    </Box>
                    : tableView
                        ? <FormTableComponent searched={searched} sort={sort} />
                        : <FormCardComponent searched={searched} sort={sort} />
                : <></>
        }
    </Box>;
};

export default FormComponent;